import { ToastMessage, ToastService } from '@akmf/ngx-ui-lib';
import { AppInjector } from '@core/classes/app.injector';
import { TranslocoService } from '@jsverse/transloco';

export class Toasts {
  private static get service(): ToastService {
    return AppInjector.injector.get(ToastService);
  }
  private static get transloco(): TranslocoService {
    return AppInjector.injector.get(TranslocoService);
  }

  public static show(msg: ToastMessage): void {
    this.service.add({
      life: 5000,
      ...msg,
      detail: this.transloco.translate(msg.detail ?? ''),
      summary: this.transloco.translate(msg.summary ?? ''),
    });
  }
}
